import React from "react";
import {
  getSmsConfig,
  updateSmsConfig
} from "adminApi/SmsSettingApi/SmsSetting";
import { validateForm } from "utils/validation";
import { SmsSettingRules } from "validation/ValidationRules";
import Spinner from "Common/Globle/Spinner";
import SmsConfigForm from "./Componate/SmsConfigForm";
import fields from "../json/SmsSettingFields.json";
import useFormChange from "Hooks/useFormChange";
import useFormSubmit from "Hooks/useFormSubmit";
import useFetchFormDataById from "Hooks/useFetchFormDataById";
import { useRoleVerify } from "Common/RoleVerify";

/**
 * SmsConfig Component
 * Manages SMS gateway configuration (provider settings, API keys, etc.)
 */
const SmsConfig = () => {
  // Check user edit permissions
  const canUpdate = useRoleVerify("", ["can_edit"]);
  const { SmsConfigFormData } = fields;

  // Initialize form state
  const initialValues = SmsConfigFormData.reduce(
    (acc, field) => ({ ...acc, [field.name]: field.type === "switch" ? "0" : "" }),
    {}
  );

  const { values, errors, handleChange, setValues, setErrors } = useFormChange(
    initialValues,
    SmsSettingRules
  );

  // Fetch existing SMS configuration (assuming ID 1 for global config)
  const { loading: loadingFetch } = useFetchFormDataById(
    '1',
    SmsConfigFormData,
    getSmsConfig,
    setValues
  );

  // Hook for handling configuration updates
  const { loading: loadingSubmit, handleSubmit } = useFormSubmit(
    async (formValues) => {
      // Production refinement: Sending clean JSON object instead of FormData
      return await updateSmsConfig({ data: formValues });
    },
    (vals) => {
      // Remove masked sensitive fields to bypass length validation
      if (vals.api_key && vals.api_key.includes("*")) delete vals.api_key;
      if (vals.api_secret && vals.api_secret.includes("*")) delete vals.api_secret;
      if (vals.auth_token && vals.auth_token.includes("*")) delete vals.auth_token;
      
      // Perform frontend validation
      const validationErrors = validateForm(vals, SmsSettingRules);
      setErrors(validationErrors);
      console.log("validationErrors", validationErrors);
      return validationErrors;
    },
    () => {
      // Optional success callback
    },
    "SMS configuration updated successfully!"
  );

  return (
    <>
      {/* Show spinner during data fetch or submission */}
      {(loadingFetch || loadingSubmit) && <Spinner isSpinner={true} />}

      <SmsConfigForm
        fields={SmsConfigFormData}
        values={values}
        errors={errors}
        handleChange={handleChange}
        handleSubmit={(e) => handleSubmit(e, values)}
        loading={loadingSubmit}
        title="SMS Gateway Configuration"
        canUpdate={canUpdate}
      />
    </>
  );
};

export default SmsConfig;
